type ElementOf<T, K extends keyof T> = T[K] extends Array<infer U> ? U : never;

export class ArrayHelpers {
  static chunk = <Element>(input: Element[], size: number): Element[][] => {
    return input.reduce((array, item, index) => {
      return index % size === 0 ? [...array, [item]] : [...array.slice(0, -1), [...array.slice(-1)[0], item]];
    }, []);
  };

  static mapProps = <T, K extends keyof T, V extends keyof ElementOf<T, K>>(
    item: T,
    singleProp: K,
    arrayProp: K,
    nestedKey: V,
  ): string[] => {
    const result: string[] = [];

    const singleValue = item[singleProp];
    if (typeof singleValue === 'string') {
      result.push(singleValue);
    }

    const arrayValue = item[arrayProp];
    if (Array.isArray(arrayValue)) {
      for (const el of arrayValue) {
        const nestedValue = el[nestedKey];
        if (typeof nestedValue === 'string') {
          result.push(nestedValue);
        }
      }
    }

    return result;
  }
}
